import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import SchoolIcon from '@mui/icons-material/School'
import CircleIcon from '@mui/icons-material/Circle'

import { Card } from './Card'
import DoughnutChart2 from '../Charts/DoughnutChart2'

export const Education = ({ labels, data, total, sx }) => {
  const { t } = useTranslation()
  return (
    <Card
      sx={{
        minHeight: '200px',
        height: '200px',
        display: 'flex',
        flexDirection: 'row',
        p: '16px',
        px: '31px',
        pb: '20px',
        ...sx
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Typography
          sx={{
            fontSize: '14px',
            color: 'rgba(0, 0, 0, 0.6)',
            width: '137px',
          }}
        >
          {t('card.levelEducation')}
        </Typography>
        <Typography
          sx={{
            fontSize: '34px',
            fontWeight: 400,
            color: 'rgba(0, 0, 0, 0.87)',
          }}
        >
          {total}
        </Typography>

        <SchoolIcon
          sx={{
            width: '35.98px',
            height: '34.05px',
            color: total === 0 ? '#DBDBDB' : '#FF5E1E',
          }}
        />
      </Box>

      
        <Box
          sx={{
            display: total ? 'none' : 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '110px',
              height: '110px',
              border: '10px solid #DBDBDB',
              borderRadius: '100%',
              justifyContent: 'center',
              color: 'rgba(0, 0, 0, 0.38)',
              mt: '30px',
              ml: '-45px',
            }}
          ></Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '10px',
              ml: '32px',
            }}
          >
            <CircleIcon
              sx={{ color: '#DBDBDB', width: '9px', height: '9px' }}
            />
            <Typography sx={{ width: '124px' }}>
              {t('card.gender.subtitle')}
            </Typography>
          </Box>
        </Box>

        <DoughnutChart2 labels={labels} data={data} />
     
    </Card>
  )
}
